module.exports = __webpack_public_path__ + "img/miniP1.75b96260.jpg";